export type HubKey = "netherlands" | "sweden" | "brasil" | "china";

export interface HubOption {
  key: HubKey;
  label: string;
  code: string;
}

export const HUB_OPTIONS: HubOption[] = [
  { key: "netherlands", label: "Netherlands", code: "NL" },
  { key: "sweden", label: "Sweden", code: "SE" },
  { key: "brasil", label: "Brasil", code: "BR" },
  { key: "china", label: "China", code: "CN" },
];

export function normalizeHub(value?: string | null): HubKey | null {
  const normalized = value?.trim().toLowerCase();

  if (normalized === "netherlands" || normalized === "nl") return "netherlands";
  if (normalized === "sweden" || normalized === "se") return "sweden";
  if (normalized === "brasil" || normalized === "brazil" || normalized === "br")
    return "brasil";
  if (normalized === "china" || normalized === "cn") return "china";

  return null;
}

export function hubOption(value?: string | null) {
  const key = normalizeHub(value);
  return HUB_OPTIONS.find((hub) => hub.key === key) ?? null;
}

export function hubLabel(value?: string | null) {
  return hubOption(value)?.label ?? "No hub";
}
